import { msg } from "@lingui/core/macro";
import { createSignal, onCleanup, onMount } from "solid-js";
import { CloudOff } from "lucide-solid";
import { useI18n } from "@/providers/i18n-provider";
import { AnimatedSection } from "./ui/animated-section";

export function OfflineBanner() {
  const { t } = useI18n();
  const [isOnline, setIsOnline] = createSignal(navigator.onLine);

  onMount(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    globalThis.addEventListener("online", handleOnline);
    globalThis.addEventListener("offline", handleOffline);

    onCleanup(() => {
      globalThis.removeEventListener("online", handleOnline);
      globalThis.removeEventListener("offline", handleOffline);
    });
  });

  return (
    <AnimatedSection show={!isOnline()}>
      {/* A11y: announce the offline/online transition to screen readers. */}
      <div
        role="status"
        aria-live="polite"
        class="flex h-10 items-center justify-center gap-2 bg-amber-500 px-4 text-center text-xs font-bold text-amber-950"
      >
        <CloudOff class="h-4 w-4" />
        {t(msg`You are working in offline mode. Changes will sync when connection is restored.`)}
      </div>
    </AnimatedSection>
  );
}
